












































import { Component, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";

@Component({
  components: {
    "client-login-fields": () =>
      import("@/components/app/client/clientLoginFields.vue")
  }
})
export default class ClientLoginModal extends Mixins(HasValidation) {
  public user = {
    email: "",
    password: ""
  };
  public isProcessing = false;

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      //@ts-ignore
      await this.$refs.clientLoginFields.login();
      this.$emit("logged-in");
    } catch (error) {
      if (error === "cancelled") {
        return;
      }
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }
}
